import { useConsole } from "contexts/Console"
import useSSR from "hooks/useSSR"

export default function Globe({ iframe_url }) {
  const ssr = useSSR()
  const console = useConsole()
  
  if (ssr) return null
  const iframeUrl = new URL(iframe_url)
  iframeUrl.searchParams.set("origin", "dotcom")
  console.verbose("Globe(%o)", { iframeUrl })
  return <iframe src={iframeUrl} width='100%' height='850px' tabIndex="0" title='description' allow='fullscreen https://www.rolex.org https://spirit.rolex.cn' />
}
